import React from 'react'

const Sleep = () => {
  return (
    <div className=' gap-5 px-2 lg:flex md:flex grid mt-10'>
    <div className='mt-5 lg:w-1/2 md:w-1/2 w-2/2' >
      <h3 className='text-[30px] font-bold'>Sleep Apnea is a potentially serious disorder</h3>
      <h3>Lorem ipsum dolor sit amet consectetur adipisicing elit. Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugit, a. Fuga labore laboriosam voluptatem asperiores recusandae quidem unde vero aut, non nesciunt, repellat optio illum nulla expedita adipisci nemo corporis. Quia inventore ipsa molestiae repellendus officiis recusandae possimus necessitatibus eligendi adipisci, doloribus quos facilis alias nemo tempora facere. Neque voluptatibus adipisci sint.</h3>

    </div>
    
    <img className="w-[300px] h-[300px] lg:grid md:grid hidden " src={require("../assets/Inspire Sleep Apnea Innovation - Obstructive Sleep Apnea Treatment.jpg")} alt=""  />

 
  </div>
  )
}

export default Sleep
